/**
 * Engineering page — sub-tabs (Coil Configurator + future tools) + active tool content.
 * Same layout pattern as HeatProfilePage / Technical section (tabs left-aligned).
 */

import React from 'react';
import CoilConfiguratorPage from '../../components/CoilConfigurator/CoilConfiguratorPage';
import EngineeringSubTabs from './EngineeringSubTabs';
import '../technical/HeatProfilePage.css';

const EngineeringPage = () => (
  <div className="heat-profile-page">
    <EngineeringSubTabs />
    <div className="heat-profile-content-wrapper">
      <CoilConfiguratorPage />
    </div>
  </div>
);

export default EngineeringPage;
